import React, { useEffect, useState } from "react";
import moment from "moment";
import ToneModal from "./modal/ToneModal";
import ReactTable from "../../common/react-table/ReactTable";
import ConfirmationModal from "../../common/modal/ConfirmationModal";
import { showWarning } from "../../utils/messageHelper";
import actionImg from "../../assets/images/action.svg";
import trashImg from "../../assets/images/trash.svg";
import editImg from "../../assets/images/edit.svg";
import { useDispatch, useSelector } from "react-redux";
import { getTone } from "../../features/tones/getToneSlice";
import { bulkDeleteTones } from "../../features/tones/bulkDeleteToneSlice";
import { deleteTone } from "../../features/tones/deleteToneSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import mixpanel from "mixpanel-browser";
import Loader from "../../common/loader/Loader";

export default function Tones({
  currentModal = "",
  searchText = "",
  setShowToneBulkDeleteBtn = () => {},
  setCurrentModal = () => {},
  toggleFunction = () => {},
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [modalTone, setModalTone] = useState({});
  const [deleteModalTone, setDeleteModalTone] = useState({});
  const [modalTitle, setModalTitle] = useState("Add Tone ");
  const [selectedRowsID, setSelectedRowsID] = useState([]);
  const dispatch = useDispatch();
  
  const { tones, pagination, isLoading: isLoadingGet } = useSelector((state) => state?.getToneReducer);
  const { isLoading: isLoadingDelete } = useSelector((state) => state?.deleteToneReducer);

  const getToneFunction = async () => {
    dispatch(getTone({ perPage, page: currentPage, search: searchText ?? "" }));
  };

  useEffect(() => {
    getToneFunction();
  }, [currentPage, perPage]);

  const handleTotalPage = (page) => {
    setPerPage(Number(page));
    setCurrentPage(1);
  };

  const handleCurrentPage = (page) => {
    setCurrentPage(Number(page));
  };

  useEffect(() => {
    if (currentModal === "addTone") {
      setModalTitle("Add Tone ");
      setModalTone({});
    }
    else {
      setModalTitle("Edit Tone ");
    }
  }, [currentModal]);

  useEffect(() => {
    setShowToneBulkDeleteBtn(selectedRowsID.length > 0);
  }, [selectedRowsID]);

  useEffect(() => {
    getToneFunction();
  }, [searchText]);

  const deleteToneModel = async () => {
    mixpanel.track("Delete tone  Button Clicked", {
      Page: "Delete tone Modal",
    });
    if (deleteModalTone?.uuid) {
      if (!deleteModalTone.is_default) {
        await dispatch(deleteTone(deleteModalTone.uuid));
        getToneFunction();
      }
      else {
        showWarning("You can not delete default tone ");
      }
    }
    setCurrentModal("");
  }

  const bulkDeleteTone = async () => {
    await dispatch(bulkDeleteTones(selectedRowsID.map(row => row.original.uuid)));
    setCurrentModal("");
    setSelectedRowsID([]);
    getToneFunction();
  }

  const columns = [
    {
      Header: "Name",
      accessor: (data) => (
        <div className="d-flex white-space-nowrap">
          <div className="prompt-td">
            <span className="d-block  personatable-span">{data.name}
              <div className="personatable-tooltip">
                {data.description}
              </div>
            </span>
            {data.is_default ? 
              <div className="dflut-tag tones-table-dftag">Default</div>
              : null
            }
          </div>
        </div>
      ),
    },
    // {
    //   Header: "Description",
    //   accessor: (data) => (
    //     <div className="doc-name tones-table-dectiption">
    //       <p>{data.description}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "Created By",
      accessor: (data) => (
        <p className="doc-name white-space-nowrap">
          {data.user?.first_name ?? ""} {data.user?.last_name}
        </p>
      ),
    },
    {
      Header: "Created Date",
      accessor: (data) => (
        <p className="doc-name white-space-nowrap">
          {moment(data?.created_at).format("MMM DD, YYYY")}
        </p>
      ),
    },
    {
      Header: "Action",
      disableSortBy: true,
      accessor: (data) => (
        <div className="dropdown action-dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img src={actionImg} alt="" />
          </button>
          <ul className="dropdown-menu">
            <li
              className="dropdown-item mt-1"
              onClick={() => {
                setCurrentModal("editTone");
                setModalTone({ ...data });
              }}
            >
              <span>
                <img src={editImg} className="user-table-drow-img" alt="" />
              </span>
              Edit
            </li>
            <li
              className="dropdown-item mt-1 delete-btn"
              onClick={() => {
                setCurrentModal("deleteTone");
                setDeleteModalTone({ ...data });
              }}
            >
              <span>
                <img
                  src={trashImg}
                  className="user-table-drow-img"
                  alt=""
                />
              </span>
              Delete
            </li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <>
      {(isLoadingDelete || isLoadingGet) && <Loader />}
      <div>
        <ReactTable
          columns={columns}
          data={tones}
          currentPage={currentPage}
          perPage={perPage}
          totalCount={pagination.total_records}
          handlePerPage={handleTotalPage}
          onPageChange={handleCurrentPage}
          emptyMessage="No tones found."
          className="tones-table"
          isCheckBox={true}
          selectedRowsID={selectedRowsID}
          setSelectedRowsID={setSelectedRowsID}
        />
      </div>
      <ToneModal
        isVisible={currentModal === "addTone" || currentModal === "editTone"}
        tone={modalTone}
        toggleFunction={toggleFunction}
        modalTitle={modalTitle}
      />
      <ConfirmationModal
        title={"Delete tone "}
        isOpen={currentModal === "deleteTone"}
        toggle={toggleFunction}
        onConfirm={deleteToneModel}
        message="Are you sure you want to delete this tone?"
      />
      <ConfirmationModal
        title={"Delete selected tones"}
        isOpen={currentModal === "bulkDeleteTones"}
        toggle={toggleFunction}
        onConfirm={bulkDeleteTone}
        message="Are you sure you want to delete selected tones?"
      />
    </>
  );
}

